module.exports = __webpack_public_path__ + "img/left-arrow-icon.1d1685b9.svg";